module.exports = __webpack_public_path__ + "img/not-authorized.ddc3fc86.svg";